export default __webpack_public_path__ + "static/media/planet-neptune.af322961.svg";